import { CREATE, EDIT, VIEW } from "./constants";

export const filters = [
  {
    name: "businessPartnersPage.filters.filter1",
    key: "My Business Partners",
  },
  {
    name: "businessPartnersPage.filters.filter2",
    key: "Prospect",
  },
  {
    name: "businessPartnersPage.filters.filter3",
    key: "Lead",
  },
  {
    name: "businessPartnersPage.filters.filter4",
    key: "Customer",
  },
  {
    name: "businessPartnersPage.filters.filter5",
    key: "Lapsed",
  },
  {
    name: "businessPartnersPage.filters.filter6",
    key: "ROLE EXPIRY IN SIX MONTHS",
  },
  {
    name: "businessPartnersPage.filters.filter7",
    key: "ROLE EXPIRY IN LAST SIX MONTHS",
  },
];

export const bpPagePoints = [
  {
    name: "businessPartnerDetailPage.pagePoints.details",
    url: "#details",
    id: "details",
    mode: [VIEW, EDIT, CREATE],
    visible: true,
  },
  {
    name: "businessPartnerDetailPage.pagePoints.contacts",
    url: "#contacts",
    id: "contacts",
    mode: [VIEW],
    visible: true,
  },
  {
    name: "businessPartnerDetailPage.pagePoints.contracts",
    url: "#contracts",
    id: "contracts",
    mode: [VIEW],
    visible: true,
  },
  {
    name: "businessPartnerDetailPage.pagePoints.discountCategories",
    url: "#discountcategories",
    id: "discountcategories",
    mode: [VIEW],
    visible: true,
  },
  {
    name: "businessPartnerDetailPage.pagePoints.orders",
    url: "#orders",
    id: "orders",
    mode: [VIEW],
    visible: true,
  },
  {
    name: "businessPartnerDetailPage.pagePoints.designatedRetailers",
    url: "#designatedRetailers",
    id: "designatedRetailers",
    mode: [VIEW],
    visible: true,
  },
  {
    name: "businessPartnerDetailPage.pagePoints.bpRoles",
    url: "#bpRoles",
    id: "bpRoles",
    mode: [VIEW],
    visible: true,
  },
  {
    name: "businessPartnerDetailPage.pagePoints.connections",
    url: "#connections",
    id: "connections",
    mode: [VIEW],
    visible: true,
  },
  {
    name: "businessPartnerDetailPage.pagePoints.timeline",
    url: "#timeline",
    id: "timeline",
    mode: [VIEW],
    visible: true,
  },
  {
    name: "businessPartnerDetailPage.pagePoints.eligibleDomains",
    url: "#eligibledomains",
    id: "eligibledomains",
    mode: [VIEW],
    visible: true,
  },
];
